define('views/blocks/LoaderView',['underscore',
        'jquery',
        'backbone',
        'app',
        'CSS3Events'
],
    function (_,
              $,
              Backbone,
              app,
              CSS3Events  
    ) {

    //
    // Header View
    //
    
    //
    // le header est un singleton,
    // 
    var self;

    return Backbone.View.extend({

        el:'.site-loader',
        events: {},

        initialize:function(){
            self = this;
            self.render(false);
            self.listenTo(app,'hideLoader', self.hide);
        },

        hide: function(){
            self.$el.addClass('inactive').on(CSS3Events('transitionend'), function () {
                self.remove();
            });
        }


    });
});
